<template>
    <div class="chart-wrapper d-flex align-items-center bg-white border rounded-3">
        <div id="chart"></div>
    </div>
</template>

<script>
import Highcharts from 'highcharts'

export default {
    name: 'PvSavingsChart',
    props: {
        oldBillsArray: Array,
        newBillsArray: Array
    },
    data: () => ({
        chart: null,
    }),
    watch: {
        oldBillsArray(value) {
            this.chart.series[0].update({data: value}, true);
        },
        newBillsArray(value) {
            this.chart.series[1].update({data: value}, true);
        },
    },
    mounted() {
        this.chart = Highcharts.chart('chart', {
            title: {
                text: this.$t('calculator.Bills over 25 years')
            },

            yAxis: {
                title: {
                    text: this.$t('calculator.Bills')
                }
            },

            tooltip: {
                shared: true,
                crosshairs: true
            },

            colors: ['#FF9700','#2775F9'],

            plotOptions: {
                series: {
                    marker: {
                        enabled: false,
                    },
                    label: {
                        enabled:false,
                        connectorAllowed: false
                    },
                    pointStart: 2022
                }
            },

            series: [{
                name: 'Rachunki bez PV',
                data: this.oldBillsArray
            }, {
                name: 'Rachunki z PV',
                data: this.newBillsArray
            }],

            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 5000
                    },
                    chartOptions: {
                        legend: {
                            layout: 'horizontal',
                            align: 'center',
                            verticalAlign: 'bottom'
                        }
                    }
                }]
            }

        });
    },
}
</script>

<style lang="scss" scoped>
.chart-wrapper {
    width: 100%;

    #chart {
        width: 100%;
        display: block;
    }
}
</style>
